import usePermissions from "hooks/usePermissions";
const useAuthorizedAttributes = (attributes) => {
  const { isPermitted } = usePermissions();
  return attributes.filter(({ permissions }) => !(permissions == null ? void 0 : permissions.length) || isPermitted(permissions));
};
export default useAuthorizedAttributes;
